// Layout peserta: sidebar + konten; tombol < menyembunyikan sidebar di layar besar (lg+).
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './navbar_peserta/Navbar';

const SIDEBAR_WIDTH = '15rem';

const PesertaLayout = () => {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

    return (
        <div className="layout-fluid">
            <div className="d-flex flex-nowrap w-100 position-relative" style={{ minHeight: '100vh' }}>
                {!sidebarCollapsed && <Navbar />}
                {!sidebarCollapsed && (
                    <button
                        type="button"
                        className="btn btn-light border shadow-sm position-fixed d-none d-lg-flex align-items-center justify-content-center rounded-circle p-0"
                        style={{
                            left: `calc(${SIDEBAR_WIDTH} - 16px)`,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            zIndex: 1055,
                            width: 32,
                            height: 32,
                            fontSize: '1rem',
                        }}
                        onClick={() => setSidebarCollapsed(true)}
                        title="Sembunyikan menu"
                        aria-label="Sembunyikan menu"
                    >
                        <span aria-hidden="true">&lt;</span>
                    </button>
                )}
                {sidebarCollapsed && (
                    <button
                        type="button"
                        className="btn btn-light border shadow-sm position-fixed d-none d-lg-flex align-items-center justify-content-center rounded-circle p-0"
                        style={{
                            top: '50%',
                            left: 12,
                            transform: 'translateY(-50%)',
                            zIndex: 1055,
                            width: 36,
                            height: 36,
                            fontSize: '1rem',
                        }}
                        onClick={() => setSidebarCollapsed(false)}
                        title="Tampilkan menu"
                        aria-label="Tampilkan menu"
                    >
                        <span aria-hidden="true">&gt;</span>
                    </button>
                )}
                <div className={`page flex-grow-1 ${sidebarCollapsed ? 'w-100' : ''}`} style={{ minWidth: 0 }}>
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default PesertaLayout;